/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Phantom District - Volumetric Smoke Parallax Scroll Effect & Tab Visibility
document.addEventListener('DOMContentLoaded', function() {
  const fogContainer = document.querySelector('.phantom-fog-container');
  const wrapper1 = document.querySelector('.phantom-fog-wrapper-1');
  const wrapper2 = document.querySelector('.phantom-fog-wrapper-2');
  const wrapper3 = document.querySelector('.phantom-fog-wrapper-3');

  // Pausar animações da névoa quando a aba estiver em segundo plano (Page Visibility API)
  if (fogContainer) {
    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        fogContainer.style.animationPlayState = 'paused';
        const fogLayers = fogContainer.querySelectorAll('.phantom-fog-layer');
        for (let i = 0; i < fogLayers.length; i++) {
          fogLayers[i].style.animationPlayState = 'paused';
        }
      } else {
        fogContainer.style.animationPlayState = 'running';
        const fogLayers = fogContainer.querySelectorAll('.phantom-fog-layer');
        for (let i = 0; i < fogLayers.length; i++) {
          fogLayers[i].style.animationPlayState = 'running';
        }
      }
    }, { passive: true });
  }

  // Desativar efeito de névoa no scroll em celulares para garantir 60 FPS
  if ((wrapper1 || wrapper2 || wrapper3) && window.innerWidth > 768) {
    let ticking = false;
    let lastScrollY = -1;

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          const scrollY = window.scrollY || window.pageYOffset;
          if (scrollY !== lastScrollY) {
            lastScrollY = scrollY;
            const move1 = (scrollY * 0.12).toFixed(1);
            const move2 = (scrollY * 0.18).toFixed(1);
            const move3 = (scrollY * 0.08).toFixed(1);
            if (wrapper1) wrapper1.style.transform = `translate3d(0, ${move1}px, 0)`;
            if (wrapper2) wrapper2.style.transform = `translate3d(0, -${move2}px, 0)`;
            if (wrapper3) wrapper3.style.transform = `translate3d(0, ${move3}px, 0)`;
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // Phantom District - Animação Scroll-Driven do Hero para o Header (Homepage)
  initPhantomHeroScrollAnimation();

  // Phantom District - Header Transparente com Inversão de Cores e Estados por Rolagem
  initPhantomHeaderScrollBehavior();

  // Phantom District - Controle Condicional do Contador do Carrinho (igual Wishlist)
  initPhantomHeaderCartCount();
});

// ==========================================================================
// PHANTOM DISTRICT — HEADER SCROLL BEHAVIOR
// Estado A (Topo): Transparente
// Estado B (Rolando para baixo): Transparente sobreposto com mix-blend-mode: difference
// Estado C (Rolando para cima): Fundo preto sólido (#000000) com transição suave
// ==========================================================================
function initPhantomHeaderScrollBehavior() {
  const headerSection = document.getElementById('shopify-section-header') || document.querySelector('.shopify-section--header');
  if (!headerSection) return;

  let lastScrollY = window.scrollY || window.pageYOffset || 0;
  let scrollThreshold = 6; // Pequeno limiar para ignorar micro-oscilações de trackpad/toque
  let ticking = false;

  function updateHeaderState() {
    const currentScrollY = window.scrollY || window.pageYOffset || 0;
    const diff = currentScrollY - lastScrollY;

    if (currentScrollY <= 15) {
      // Estado A — Topo da página: Transparente sem faixa preta
      headerSection.classList.add('is-at-top');
      headerSection.classList.remove('is-scroll-down', 'is-scroll-up');
    } else if (Math.abs(diff) >= scrollThreshold) {
      if (diff > 0) {
        // Estado B — Rolando para baixo: 100% Transparente sobreposto
        headerSection.classList.add('is-scroll-down');
        headerSection.classList.remove('is-scroll-up', 'is-at-top');
      } else {
        // Estado C — Rolando para cima: Fundo preto sólido (#000000)
        headerSection.classList.add('is-scroll-up');
        headerSection.classList.remove('is-scroll-down', 'is-at-top');
      }
      lastScrollY = currentScrollY;
    }

    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeaderState);
      ticking = true;
    }
  }, { passive: true });

  updateHeaderState();
}

function initPhantomHeroScrollAnimation() {
  const heroSubtitle = document.getElementById('phantom-hero-subtitle-el') || document.querySelector('.phantom-editorial-subtitle');
  const heroTitle = document.getElementById('phantom-hero-title-el');
  const heroLogo = document.getElementById('phantom-hero-logo-png-el');
  const headerLogoTarget = document.getElementById('header-logo-target') || document.querySelector('.header__logo');
  const headerCenterTarget = document.getElementById('header-center-logo-target');
  const heroPoster = document.getElementById('phantom-hero-poster');
  const basePosterOpacity = heroPoster ? (parseFloat(heroPoster.getAttribute('data-base-opacity') || 100) / 100.0) : 1;

  // Sincronizar a logo 3D prateada no centro do header
  if (heroLogo && heroLogo.src && headerCenterTarget) {
    const centerImg = headerCenterTarget.querySelector('img');
    if (centerImg && centerImg.src !== heroLogo.src) {
      centerImg.src = heroLogo.src;
    }
  }

  // Se não estiver na Homepage com a seção Hero, garantir visibilidade imediata dos elementos do header
  if (!heroTitle || !heroLogo) {
    if (headerCenterTarget) {
      headerCenterTarget.style.opacity = '1';
      headerCenterTarget.style.visibility = 'visible';
    }
    if (headerLogoTarget) {
      const staticLink = headerLogoTarget.querySelector('.header__logo-link');
      if (staticLink) {
        staticLink.style.opacity = '1';
        staticLink.style.visibility = 'visible';
      }
    }
    return;
  }

  // Verificar se a section possui a configuração de desativar animação no celular
  const heroSection = document.querySelector('.phantom-hero-section');
  const isMobile = window.innerWidth <= 768;
  const isMobileAnimDisabled = heroSection && heroSection.getAttribute('data-disable-mobile-anim') === 'true';

  if (isMobileAnimDisabled && isMobile) {
    heroTitle.style.transform = 'none';
    heroLogo.style.transform = 'none';
    heroTitle.style.opacity = '1';
    heroLogo.style.opacity = '1';
    heroTitle.style.visibility = 'visible';
    heroLogo.style.visibility = 'visible';
    if (heroSubtitle) heroSubtitle.style.opacity = '1';
    if (headerCenterTarget) {
      headerCenterTarget.style.opacity = '1';
      headerCenterTarget.style.visibility = 'visible';
    }
    if (headerLogoTarget) {
      const staticLink = headerLogoTarget.querySelector('.header__logo-link');
      if (staticLink) {
        staticLink.style.opacity = '1';
        staticLink.style.visibility = 'visible';
      }
    }
    return;
  }

  const staticHeaderLogoLink = headerLogoTarget ? headerLogoTarget.querySelector('.header__logo-link') : null;

  // Otimização por GPU
  heroTitle.style.willChange = 'transform, opacity';
  heroTitle.style.transformOrigin = 'center center';
  heroLogo.style.willChange = 'transform, opacity';
  heroLogo.style.transformOrigin = 'center center';
  if (heroSubtitle) heroSubtitle.style.willChange = 'opacity';
  if (headerCenterTarget) {
    headerCenterTarget.style.willChange = 'opacity';
    headerCenterTarget.style.transition = 'opacity 0.2s linear';
  }
  if (staticHeaderLogoLink) {
    staticHeaderLogoLink.style.willChange = 'opacity';
    staticHeaderLogoLink.style.transition = 'opacity 0.2s linear';
  }
  if (heroPoster) {
    heroPoster.style.willChange = 'opacity';
    heroPoster.style.transition = 'opacity 0.4s ease';
  }

  // Geometria precisa medida pontualmente (no init e no resize, NUNCA a cada evento de scroll)
  let deltaTitleX = 0, deltaTitleY = 0, titleScale = 1;
  let deltaLogoX = 0, deltaLogoY = 0, logoScale = 1;

  function calculatePositions() {
    const titleTransform = heroTitle.style.transform;
    const logoTransform = heroLogo.style.transform;
    heroTitle.style.transform = 'none';
    heroLogo.style.transform = 'none';

    const heroTitleRect = heroTitle.getBoundingClientRect();
    const heroLogoRect = heroLogo.getBoundingClientRect();
    const headerLogoRect = headerLogoTarget.getBoundingClientRect();
    const headerCenterRect = headerCenterTarget.getBoundingClientRect();

    const targetTextEl = (headerLogoTarget && (headerLogoTarget.querySelector('.header__logo-text') || headerLogoTarget.querySelector('.header__logo-link'))) || headerLogoTarget;
    const targetLogoImg = (headerCenterTarget && (headerCenterTarget.querySelector('img') || headerCenterTarget.querySelector('.header__center-logo-img'))) || headerCenterTarget;

    const targetTextRect = targetTextEl ? targetTextEl.getBoundingClientRect() : headerLogoRect;
    const targetLogoRect = targetLogoImg ? targetLogoImg.getBoundingClientRect() : headerCenterRect;

    heroTitle.style.transform = titleTransform;
    heroLogo.style.transform = logoTransform;

    const scrollY = window.scrollY || window.pageYOffset || 0;

    // 1. Centro e Escala Exatos para o Texto "PHANTOM DISTRICT" (transform-origin: center center)
    const initialTitleDocCenterX = heroTitleRect.left + heroTitleRect.width / 2;
    const initialTitleDocCenterY = heroTitleRect.top + scrollY + heroTitleRect.height / 2;
    const targetTextCenterX = targetTextRect.left + targetTextRect.width / 2;
    const targetTextCenterY = targetTextRect.top + targetTextRect.height / 2;

    deltaTitleX = targetTextCenterX - initialTitleDocCenterX;
    deltaTitleY = targetTextCenterY - initialTitleDocCenterY;
    titleScale = targetTextRect.height / (heroTitleRect.height || 1);

    // 2. Centro e Escala Exatos para a Logo 3D (transform-origin: center center)
    const initialLogoDocCenterX = heroLogoRect.left + heroLogoRect.width / 2;
    const initialLogoDocCenterY = heroLogoRect.top + scrollY + heroLogoRect.height / 2;
    const targetLogoCenterX = targetLogoRect.left + targetLogoRect.width / 2;
    const targetLogoCenterY = targetLogoRect.top + targetLogoRect.height / 2;

    deltaLogoX = targetLogoCenterX - initialLogoDocCenterX;
    deltaLogoY = targetLogoCenterY - initialLogoDocCenterY;
    logoScale = targetLogoRect.height / (heroLogoRect.height || 1);
  }

  calculatePositions();

  let resizeDebounceTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeDebounceTimeout);
    resizeDebounceTimeout = setTimeout(calculatePositions, 150);
  }, { passive: true });

  // Curva de interpolação cúbica idêntica à animação original
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  // Máquina de estados temporizada de alto desempenho
  let currentProgress = 0; // 0 = topo, 1 = header final
  let targetProgress = 0;
  let animStartProgress = 0;
  let animStartTime = 0;
  let isAnimating = false;
  let currentState = 'at-top'; // 'at-top' ou 'scrolled'
  const animDurationForward = 520; // 520ms para transição ao rolar para baixo
  const animDurationReverse = 450; // 450ms para retorno suave ao topo

  function renderFrame(progress) {
    const p = Math.max(0, Math.min(1, progress));
    const currentScrollY = window.scrollY || window.pageYOffset || 0;

    // 1. Subtítulo "MUDE AGORA"
    if (heroSubtitle) {
      const subOpacity = Math.max(0, 1 - p * 2.5);
      heroSubtitle.style.opacity = subOpacity.toFixed(2);
    }

    // 2. Movimento coordenado de Translação e Escala da Hero para a Header
    const titleX = deltaTitleX * p;
    const titleY = deltaTitleY * p + currentScrollY * p;
    const currentTitleScale = 1 + (titleScale - 1) * p;

    const logoX = deltaLogoX * p;
    const logoY = deltaLogoY * p + currentScrollY * p;
    const currentLogoScale = 1 + (logoScale - 1) * p;

    heroTitle.style.transform = `translate3d(${titleX.toFixed(1)}px, ${titleY.toFixed(1)}px, 0) scale(${currentTitleScale.toFixed(3)})`;
    heroLogo.style.transform = `translate3d(${logoX.toFixed(1)}px, ${logoY.toFixed(1)}px, 0) scale(${currentLogoScale.toFixed(3)})`;

    // 3. Handshake suave de visibilidade entre Hero e Header
    if (p >= 0.82) {
      const handFade = Math.min(1, (p - 0.82) / 0.18);
      if (headerCenterTarget) {
        headerCenterTarget.style.opacity = handFade.toFixed(2);
        headerCenterTarget.style.visibility = 'visible';
      }
      if (staticHeaderLogoLink) {
        staticHeaderLogoLink.style.opacity = handFade.toFixed(2);
        staticHeaderLogoLink.style.visibility = 'visible';
      }
      const heroOpacity = Math.max(0, 1 - handFade).toFixed(2);
      heroTitle.style.opacity = heroOpacity;
      heroLogo.style.opacity = heroOpacity;

      if (p === 1) {
        heroTitle.style.visibility = 'hidden';
        heroTitle.style.pointerEvents = 'none';
        heroLogo.style.visibility = 'hidden';
        heroLogo.style.pointerEvents = 'none';
      }
    } else {
      if (headerCenterTarget) {
        headerCenterTarget.style.opacity = '0';
        headerCenterTarget.style.visibility = 'hidden';
      }
      if (staticHeaderLogoLink) {
        staticHeaderLogoLink.style.opacity = '0';
        staticHeaderLogoLink.style.visibility = 'hidden';
      }
      heroTitle.style.opacity = '1';
      heroTitle.style.visibility = 'visible';
      heroTitle.style.pointerEvents = 'auto';
      heroLogo.style.opacity = '1';
      heroLogo.style.visibility = 'visible';
      heroLogo.style.pointerEvents = 'auto';
    }

    // 4. Poster da Hero
    if (heroPoster) {
      if (p === 0) {
        heroPoster.style.opacity = basePosterOpacity.toString();
        heroPoster.style.visibility = 'visible';
        heroPoster.style.display = 'block';
      } else if (p === 1) {
        heroPoster.style.opacity = '0';
        heroPoster.style.visibility = 'hidden';
        heroPoster.style.display = 'none';
      } else {
        const posterOp = (basePosterOpacity * Math.max(0, 1 - p * 1.5)).toFixed(3);
        heroPoster.style.opacity = posterOp;
        heroPoster.style.visibility = 'visible';
        heroPoster.style.display = 'block';
      }
    }
  }

  function tick(now) {
    if (!isAnimating) return;

    const duration = targetProgress === 1 ? animDurationForward : animDurationReverse;
    const elapsed = now - animStartTime;
    const rawProgress = Math.min(1, elapsed / duration);
    const eased = easeOutCubic(rawProgress);

    currentProgress = animStartProgress + (targetProgress - animStartProgress) * eased;
    renderFrame(currentProgress);

    if (rawProgress >= 1) {
      currentProgress = targetProgress;
      renderFrame(currentProgress);
      isAnimating = false;
      // Animação concluída e estabilizada: o rAF desliga completamente!
      return;
    }

    window.requestAnimationFrame(tick);
  }

  function startTransitionTo(target) {
    if (target === targetProgress && (isAnimating || currentProgress === target)) return;

    targetProgress = target;
    animStartProgress = currentProgress;
    animStartTime = performance.now();

    if (!isAnimating) {
      isAnimating = true;
      window.requestAnimationFrame(tick);
    }
  }

  // Verificação leve de scroll: apenas detecta a troca entre Topo (<= 0) e Scrolled (> 0)
  function onScroll() {
    const scrollY = window.scrollY || window.pageYOffset || 0;
    const atTop = scrollY <= 0;

    if (atTop) {
      if (currentState !== 'at-top') {
        currentState = 'at-top';
        document.body.classList.add('phantom-hero--at-top');
        document.body.classList.remove('phantom-hero--scrolled');
        startTransitionTo(0);
      }
    } else {
      if (currentState !== 'scrolled') {
        currentState = 'scrolled';
        document.body.classList.add('phantom-hero--scrolled');
        document.body.classList.remove('phantom-hero--at-top');
        startTransitionTo(1);
      }
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // Inicialização no carregamento da página
  const initialScrollY = window.scrollY || window.pageYOffset || 0;
  if (initialScrollY > 0) {
    currentState = 'scrolled';
    currentProgress = 1;
    targetProgress = 1;
    document.body.classList.add('phantom-hero--scrolled');
    renderFrame(1);
  } else {
    currentState = 'at-top';
    currentProgress = 0;
    targetProgress = 0;
    document.body.classList.add('phantom-hero--at-top');
    renderFrame(0);
  }
}

// ==========================================================================
// PHANTOM DISTRICT — CONTADOR CONDICIONAL DO CARRINHO (IGUAL WISHLIST)
// Oculta o indicador circular quando count <= 0 e exibe somente quando count > 0
// ==========================================================================
function initPhantomHeaderCartCount() {
  function updateCartBadge(countEl) {
    if (!countEl) return;
    const text = (countEl.textContent || '').trim();
    const count = parseInt(text, 10);
    if (!isNaN(count) && count > 0) {
      countEl.style.display = 'inline-flex';
    } else {
      countEl.style.display = 'none';
    }
  }

  function syncAllCartBadges() {
    const badges = document.querySelectorAll('.header__cart-count');
    badges.forEach(updateCartBadge);
  }

  syncAllCartBadges();

  if (window.MutationObserver) {
    const badges = document.querySelectorAll('.header__cart-count');
    badges.forEach(function(el) {
      const observer = new MutationObserver(function() {
        updateCartBadge(el);
      });
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  document.addEventListener('cart:rerendered', syncAllCartBadges);
  document.addEventListener('cart:updated', syncAllCartBadges);
  document.addEventListener('cart:refresh', syncAllCartBadges);
  window.addEventListener('pageshow', syncAllCartBadges);
}